"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const AddButton_styles_1 = require("./AddButton.styles");
const AddButton = ({ disabled, onClick }) => {
    const { container, icon } = (0, AddButton_styles_1.default)({
        disabled,
    });
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: container, onClick: onClick, children: (0, jsx_runtime_1.jsx)(icons_material_1.AddRounded, { sx: icon }) }));
};
exports.default = AddButton;
